import { IKnowledgeArea } from '../../interfaces/KnowledgeArea/KnowledgeArea'
import apiService from '../Api'

export class KnowledgeAreaService {
  async list(): Promise<IKnowledgeArea[]> {
    return apiService.get('/knowledge-areas').then((res) => res.data.areas)
  }

  async get(id: number) {
    return apiService.get(`/knowledge-areas/${id}`).then((res) => res.data)
  }

  async create(data: { name: string }) {
    return apiService.post('/knowledge-areas', data).then((res) => res.data)
  }

  async update(id: number, data: { name: string }) {
    return apiService.put(`/knowledge-areas/${id}`, data).then((res) => res.data)
  }

  async delete(id: number) {
    return apiService.delete(`/knowledge-areas/${id}`)
  }
}
